import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteForm } from 'api/Forms';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

const Actions = ({ data }) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const { setSelectedItem, setShowModal } = useTableContext();
  const { setOpenModal, setBreadCrumbs, formik, setIsEdit } = useFormBuilderContext();

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutateAsync: mutateDeleteForm } = useMutation({
    mutationFn: (data) => deleteForm(navigate, data)
  });

  const handleEdit = () => {
    setBreadCrumbs([{ title: 'Form builder', view: 'builder', active: true, isFinished: false }]);

    // eslint-disable-next-line no-unused-vars
    const { f_name, l_name, created_by, packets, formType, ...formData } = data;
    setSelectedItem(formData);

    formik.setValues({ ...formik.values, form: formData });
    setIsEdit(true);
    setOpenModal(true);
    setShowModal(true);
  };

  const handleDelete = async () => {
    const variables = { formId: data?.id };
    await mutateDeleteForm(variables, {
      onSuccess: ({ code }) => {
        if (code === 0) {
          queryClient.invalidateQueries(['forms']);
          queryClient.refetchQueries(['customForm']);
          showAlert({ title: 'Form deleted', color: 'success' });
        } else {
          showAlert({ title: "Couldn't delete form", color: 'danger' });
        }
        setShowConfirmationModal(false);
      }
    });
  };

  const handleView = () => {
    setSelectedItem(data);
    setOpenModal(true);
    setShowModal(true);
  };

  const options = [
    { label: 'View', onClick: handleView, icon: 'eye-mono' },
    { label: 'Edit', onClick: handleEdit, icon: 'edit-2-mono' },
    { label: 'Delete', onClick: () => setShowConfirmationModal(true), icon: 'trash-mono' }
  ];

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />
      <Confirm
        variant="danger"
        title="Delete form"
        icon="trash-mono"
        message="Are you sure you want to delete this form?"
        isOpen={!!showConfirmationModal}
        handleClose={() => setShowConfirmationModal(false)}
        footerActions={{
          primary: {
            text: 'Delete',
            onClick: handleDelete,
            color: 'danger'
          }
        }}
      />
    </>
  );
};

export default Actions;
